import { createContext } from 'react';
import { UserProfileDto } from '../api/web-api-client';
import { UserProfile } from '../components/SearchFilter/types';

export interface AccountDetails {
    organisation: string;
    trading: string;
    branch: string;
    homeAccountId: string;
    givenName?: string;
    familyName?: string;
    email?: string;
    abn?: string;
    targetOrganisation?: TargetOrganisation;
    userAcceptedTermsOfUse: boolean;
    accountCreationCompleted: boolean;
    accountContactCompleted: boolean;
    currentTermsVersion: string;
    defaultOrganisationId?: number;
    organisationCRMGuid?: string;
    organisationIsCompleted: boolean;
    isDefaultOrganisation: boolean;
    showBranchSelector: boolean;
    showRFQDeleteModal: boolean;
    rfqId?: string;
    contactId?: number;
    userProfile?: UserProfile;
}

export interface AccountContextState {
    isLoading?: boolean;
    details: AccountDetails | null;
    setAgree: () => void;
    setCompleted: () => void;
    setContactCompleted: () => void;
    setDefaultOrganisationId: (defaultOrganisationId: number | undefined, defaultOrganisationCRMId: string | undefined) => void;
    setTargetOrganisation: (targetOrganisationAbn: string, targetOrganisationName: string) => void;
    setOrganisationAndBranch: (organisationName: string, tradingName: string, branchName: string) => void;
    setShowBranchSelector: (show: boolean) => void;
    setShowRFQDeleteModal: (show: boolean, rfqId: string) => void;
    setUserProfile: (userProfile: UserProfileDto) => void;
}

export interface TargetOrganisation {
    targetOrganisationAbn: string;
    targetOrganisationName: string;
}

const AccountContext = createContext<AccountContextState | null>(null);

export default AccountContext;
